import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { hoverFeatured } from './featured';
import map from './map';
import { data, fetchDataError, fetchDataLoading } from './data';
import visibility from './visibility';
import { prevalence } from './prevalence';

export default combineReducers({
	routing: routerReducer,
	json: data,
	fetchDataError,
	fetchDataLoading,
	hoverFeatured,
	map,
	visibility,
	prevalence
});
